import "modules/ChecklistSettingsDashboard/ChecklistSettingsDashboard.scss";
import { ChecklistSettingsHeader, ChecklistTemplatesTable } from "modules/ChecklistSettingsDashboard/components";

export const ChecklistSettingsDashboard = () => (
  <div className="ChecklistSettingsDashboard">
    <ChecklistSettingsHeader />
    <ChecklistTemplatesTable />
  </div>
);
